import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { INofesh } from "../model/nofesh";
import { ENofeshStatus } from "../../shared/enums/enofesh-status.enum";
import { ConfigService } from "app/shared/config.service";
import { NofshonimService } from "app/nofshonim-chul/nofshonim.service";

@Component({
    moduleId: module.id,
    templateUrl: './nofesh-details.component.html'
})

export class NofeshDetailsComponent implements OnInit {
    nofesh: INofesh;
    nofeshId: number;
    nofesh_syllabus_file_url: string = "";
    is_tkufat_rishum: boolean;
    //המלאי אזל אין מקומות בהמתנה
    is_nofesh_full: boolean;
    is_nofesh_hamtana: boolean;
    is_user_selected_another_nofesh: boolean;
    isRegistedByOtherAmit: boolean;
    is_user_selected_mimush_all: boolean = false;
    is_user_selected_mimush_one: boolean = false;
    is_user_selected_only_one_zakaut: boolean = false;
    checkZakaut: boolean = true;
    apiUrl: string = ""
    currentTime: Date;
    constructor(private _activateRoute: ActivatedRoute,
        private _router: Router,
        private _configService: ConfigService
    ) {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
        this.nofesh_syllabus_file_url = `${this.apiUrl}/UploadFiles/NofeshSyllabus/`;

    }

    ngOnInit() {
        document.getElementById('menuDiv').style.display = 'none';


        this.nofeshId = this._activateRoute.snapshot.params['id'];
        if (this.nofeshId == null || this.nofeshId == undefined || this.nofeshId == 0) {
            this._router.navigateByUrl('/nofesh');
            return;
        }

        let nofashim: INofesh[] = JSON.parse(sessionStorage.getItem("nofashim"));
        if (!nofashim) {
            this._router.navigateByUrl('/nofesh');
            return;
        }

        this.nofesh = nofashim.filter(n => n.id_nofesh == this.nofeshId)[0];
        if (!this.nofesh) {
            this._router.navigateByUrl('/nofesh');
            return;
        }
        let userSelectedNofesh = JSON.parse(sessionStorage.getItem('userSelectedNofesh'));
        if (userSelectedNofesh != null) {
            // no_zakaut_check value 1 means that the nofesh is not using zakaut.
            // Amit can submit for the nofesh even if he submitted for another nofesh or was registered by other amit.
            // nofesh.no_zakaut_check is currently viewed nofesh without zakaut use.
            // userSelectedNofesh.no_zakaut_check is previously reserved nofesh without zakaut use.
            let canSubmitAnotherNofesh: boolean = Boolean(this.nofesh.no_zakaut_check) || Boolean(userSelectedNofesh.no_zakaut_check);
            if (userSelectedNofesh.id_nofesh > 0 && userSelectedNofesh.id_nofesh != this.nofeshId && !canSubmitAnotherNofesh) {
                // This value is true only if current nofesh and previously selected nofesh no_zakaut_check properties are both 0.
                // In every other case, the amit can place multiple nofashim (meurgan or nofshon).
                if (userSelectedNofesh.mimush == 1) {
                    this.is_user_selected_mimush_one = true;
                    //עובדי איכילוב
                    if (userSelectedNofesh.amuta_kidum == 1) {
                        this.is_user_selected_mimush_one = false;
                        this.is_user_selected_only_one_zakaut = true
                    }
                }

                if (userSelectedNofesh.mimush >= 2) {
                    this.is_user_selected_mimush_all = true;
                    this.is_user_selected_another_nofesh = true;
                }

            }

            if (userSelectedNofesh.id_nofesh > 0 && userSelectedNofesh.id_nofesh == this.nofeshId) {
                // This value is true only if current nofesh and previously selected nofesh no_zakaut_check properties are both 0.
                // In every other case, the amit can place multiple nofashim (meurgan or nofshon).
                this.is_user_selected_another_nofesh = true;
            }

            if (userSelectedNofesh.isRegistedByOtherAmit && !canSubmitAnotherNofesh) {
                this.isRegistedByOtherAmit = true;
            }

            // //changed by yehudit- במקרה שהוזמן נילווה עמית, העמית יוכל לבצע עוד הזמנה אם המימוש שלו !=2
            // if ( userSelectedNofesh.mimush == 2 ) {
            //     this.isRegistedByOtherAmit = true;
            // }

        }

        //let todaysDate = new Date().setHours(0,0,0,0);
        let todaysDate = new Date().getTime();
        let rishum_from = new Date(this.nofesh.fromTkufatRishum);
        let rishum_to = new Date(this.nofesh.toTkufatRishum);
        //this.is_tkufat_rishum = (todaysDate >= rishum_from.setHours(0,0,0,0)) && (todaysDate <= rishum_to.setHours(0,0,0,0));
        this.is_tkufat_rishum = (todaysDate >= rishum_from.getTime()) && (todaysDate <= rishum_to.getTime());
        this.is_nofesh_full = this.nofesh.nofesh_status == ENofeshStatus.AzalHaMelay; //(this.nofesh.reshumim_count >= this.nofesh.total_peaple && this.nofesh.mamtinim_count >= this.nofesh.total_hamtana_people)
        this.is_nofesh_hamtana = this.nofesh.nofesh_status == ENofeshStatus.Hamtana; //(this.nofesh.reshumim_count >= this.nofesh.total_peaple && this.nofesh.mamtinim_count < this.nofesh.total_hamtana_people);
    }

    order(event): void {
        event.preventDefault();
        this._router.navigate(['nofesh/order-nofesh/' + this.nofeshId]);
    }

}
